import { render, staticRenderFns } from "./ContentTypesCard.vue?vue&type=template&id=79d713e2&"
import script from "./ContentTypesCard.vue?vue&type=script&lang=ts&"
export * from "./ContentTypesCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports